// Tremor Raw Card [v0.0.0]
import { Slot } from "@radix-ui/react-slot";

import React from "react";

import { cx } from "@/lib/tailwind-utils";

interface CardProps extends React.ComponentPropsWithoutRef<"div"> {
  asChild?: boolean;
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, asChild, ...props }, forwardedRef) => {
    const Component = asChild ? Slot : "div";
    return (
      <Component
        ref={forwardedRef}
        className={cx(
          // base
          "relative w-full rounded-lg border p-4 text-left shadow-sm",
          // background color
          "bg-card",
          // border color
          "border-border",
          // text color
          "text-card-foreground",
          className,
        )}
        {...props}
      />
    );
  },
);

Card.displayName = "Card";
export default Card;

export { type CardProps };
